<template>
  <div id="scoreAnalysis">
    <template v-if="isScoreAnalysis">
      <div class="title">
        <p>
          <span class="routerName">成绩分析</span>
          <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
          <span class="planName">{{currentPlan.name}}</span>
          <el-dropdown trigger="click" style="margin-left: 8px;">
              <span class="el-dropdown-link">
              <img :src="planImg" alt="">
              </span>
              <template #dropdown>
              <el-dropdown-menu style="max-height:600px;height:auto;overflow-y:auto;">
                  <el-dropdown-item v-for="(item, index) in planList" :key="index" @click.native="changPlan(item)">{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
              </template>
          </el-dropdown>
        </p>
      </div>
      <ots-table-group-new
        :requestForm='requestForm'
        @search="search"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
      ></ots-table-group-new>
    </template>

    <template v-else>
      <router-view/>
    </template>

  </div>
</template>

<script>

import { getScorePagelist } from '@/http/modules/examReport'
import { getSelectPlanFn } from '@/http/modules/examSet/examBatch'

export default {
  data(){
    return {
      planImg: require('@/assets/img/courseChange.png'),
      planList: [],
      currentPlan: {},
      requestForm: {
        planId: '',
        size: 10,
        page: 1,
      },
      tableData: [],
      tableHeader: [
          {
              title: "考试科目",
              prop: "courseName",
          },
          {
              title: "应考人数",
              prop: "payStuCount"
          },
          {
              title: "参考人数",
              prop: "examedStuCount",
          },
          {
              title: "缺考人数",
              prop: "unexamStuCount",
          },
          {
              title: "违纪人数",
              prop: "unusualStuCount",
          },
          {
              title: "参考率",
              prop: "examedPercent",
          },
          {
            title: "缺考率",
              prop: "unexamPercent"
          },
          {
              title: "违纪率",
              prop: "unusualPercent"
          },
         
          {
            title: "合格人数",
              prop: "passStuCount"
          },{
            title: "优秀人数",
              prop: "excellentStuCount"
          },{
            title: "合格率",
              prop: "passPercent"
          },{
            title: "优秀率",
              prop: "excellentPercent"
          },
          {
              title: "平均分",
              prop: "avgScore"
          },
          {
              title: "科目成绩分析",
              type: "buttons",
              btnList: [
                {
                  title: '查看',
                  click: this.lookDetail,
                },
              ]
          }
      ],
      pagination: {
          total: 0
      },
    }
  },
  computed:{
    isScoreAnalysis(){
      return this.$route.name == 'scoreAnalysis'
    },
  },
  watch: {
    'currentPlan': 'planIsChange'
  },
  created(){
    this.initData()
  },
  methods: {
    async getPlanInfo() {
      const { data: planInfo } = await this.$api.applyManage.getCurrentPlan({ planId: this.requestForm.planId });
      this.currentPlan = planInfo
    },

    // 初始化数据
    initData(){
      getSelectPlanFn({needAudit: 2}).then(({data}) => {
        this.planList = data;
        let id = this.$route.query.planId;
        if(id){
          this.requestForm.planId = id;
          this.getPlanInfo();
        } else {
          this.currentPlan = data[0]
          this.requestForm.planId = data[0].id
        }
      })
    },
    planIsChange(){
      this.search()
    },
    // 批次切换
    changPlan(value){
      this.currentPlan = value
      this.requestForm.planId = value.id
    },
    // 搜索
    search(){
      let params = {...this.requestForm}
      getScorePagelist(params).then(res=>{
        this.tableData = res.data.records
        this.pagination.total = res.data.total
      })
    },
    lookDetail(val){
      let params = {...val};
      params.planId = this.currentPlan.id;
      params.planName = this.currentPlan.name;
      this.$router.push({path: 'scoreAnalysis/scoreAnalysisInfo', query: params})
    },

    changeNum(num) {
      this.requestForm.size = num
      this.search()
    },

    changePage(p) {
      this.requestForm.page = p
      this.search()
    },
  }
}
</script>

<style scoped lang="less">
#scoreAnalysis {
  // 标题 -- 批次名
  .title {
    height: 32px;
    p {
      .routerName {
        font-size: 14px;
        color: #9299A6;
      }
      .planName {
        font-size: 24px;
        font-weight: 500;
        color: #2D2F33;
      }
      .el-dropdown-link {
        cursor: pointer;
        color: var(--el-color-primary);
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
